import React, { useEffect } from 'react';
import DialogSelectionProject from '@app/components/DialogSelectionProject';
import { Loading } from '@app/components/Loading';
import { HttpStatusCode } from '@app/modules/error-handler/ErrorHandleModel';
import { UserUtils } from '@app/modules/userinfo';
import { NAVIGATE_ROUTE } from '../common-route';
import { AuthGuard } from '../guards';
import { PrivateAndPublicRouteProps } from '../types';
import withTabHandler from './withTabHandler';

const PrivateRoute = ({ Component }: PrivateAndPublicRouteProps) => {
  // Refresh user cache on every private page access (sliding window expiration)
  useEffect(() => {
    UserUtils.refreshCache().catch((err) => {
      // Silently fail - cache refresh is non-critical
      console.warn('Cache refresh failed:', err);
    });
  }, []);

  return (
    <React.Suspense fallback={<Loading fullScreen blocked />}>
      <AuthGuard requireAuth={true} redirectTo={NAVIGATE_ROUTE.SC014} statusCode={HttpStatusCode.Unauthorized}>
        <Component />
        {/* Dialog selection project common */}
        <DialogSelectionProject />
      </AuthGuard>
    </React.Suspense>
  );
};

export default withTabHandler(PrivateRoute);
